export default __webpack_public_path__ + "static/media/rotted_curtains2.087e2857.png";